import Vue from 'vue'
import Router from 'vue-router'
import { domain } from './config/firebaseConfig'
import store from './store'

Vue.use(Router)

let router = new Router({
  routes: [
    { path: '/', component: () => import('./views/Landing.vue') },
    { name: 'Store', path: '/:storeId/store', component: () => import('./views/Store.vue') },
    { name: 'Landing', path: '/landing', component: () => import('./views/Landing.vue') },
    { path: '/:storeId/product/:id', component: () => import('./views/ProductDetails') },
    { path: '/cart', name: 'cart', component: () => import('./views/ShoppingCart') },
    { path: '/order/:id', component: () => import('./views/Order') },
    { path: '/orders', component: () => import('./views/Orders') },
    { path: '*', name: 'redirect', redirect: '/' }
  ]
})
router.beforeEach((to, from, next) => {
  if (to.name !== 'Store' && store.getters.shopId === '' && to.path !== '/landing' && domain === '') next({ name: 'Landing' })
  else next()
})
export default router
